export const RegularExpression = {
    PASSWORD_VALIDATION: `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^\\da-zA-Z]).{8,15}$`,
    PHONE_VALIDATION: `^([\\d]){7,15}$`,
    EMAIL_VALIDATION: `^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`,
    DOMAIN_VALIDATION: `^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:.[a-zA-Z]{2,})+$`,
    NAME_VALIDATION: `^[A-Za-z0-9]*$`,
    COMPANY_NAME: `^[a-zA-Z0-9&]*$`,
    ONLY_NUMBERS: `^[0-9]*$`,
    ONLY_LETTERS: `^[A-Za-z]*$`,
    CARD_NUMBER: `^[0-9]{16}$`,
    // SHEBA_NUMBER: `/ir[0-9]{24}$/gmi`
    SHEBA_NUMBER: `^[I|i][R|r][0-9]{24}$`
};

export default RegularExpression;


// WEBPACK FOOTER //
// ./src/constants/RegularExpression.js